import { Injectable } from '@angular/core';

/*
  Generated class for the GlobalProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GlobalProvider {

  //globis管理事務局のrole.id
  public glbs_admin_role_id=1;
  //sonota
  public glbs_customer_role_id=2;
  public glbs_student_role_id=3;
  public glbs_editor_role_id=4;
  public glbs_operator_role_id=5;
  //デフォルトで選択禁止にするrole.id
  public defaultDisableAddRoleIds=[
    this.glbs_admin_role_id
    ,this.glbs_editor_role_id
    ,this.glbs_operator_role_id
  ];

  constructor(){//public http: HttpClient) {
    //console.log('Hello GlobalProvider Provider');
  }

}



// WEBPACK FOOTER //
// ./src/app/globalProvider.ts